import { validateSellListingField } from "@/lib/listing/sellListingValidation";
import type { SellListingMode } from "@/lib/listing/bulkListingTypes";

/** Step index where price + band insight UI first appears (`StepBasedForm`). */
export const SELL_LISTING_PRICE_STEP = 4;

export type SellPriceBandFetchGateInput = {
  enforcementEnabled: boolean;
  listingMode: SellListingMode;
  /** Single-item flow only; ignored for bulk. */
  currentStep: number;
  title: string;
  category: string;
};

/**
 * Option A: defer band prefetch until the seller reaches the price step (single)
 * or has a finalized title (bulk — no step wizard).
 */
export function shouldFetchSellPriceBand(
  input: SellPriceBandFetchGateInput,
): boolean {
  if (!input.enforcementEnabled) {
    return false;
  }
  if (!input.category.trim()) {
    return false;
  }

  if (input.listingMode === "bulk") {
    const title = input.title.trim();
    return (
      title.length >= 5 &&
      validateSellListingField("title", title) === undefined
    );
  }

  return input.currentStep >= SELL_LISTING_PRICE_STEP;
}
